import { createContext, useContext } from 'react';

// Named extension points a plugin module can fill in (a component, or a plain
// function) - e.g. an optional section rendered inside DetailPanel, or an
// optional fieldset + its own persist function inside KanbanBoard's move/close
// modal. Populated once from loadExtensions()'s merged `slots` map (see
// App.jsx) and provided down the tree the same way LookupsContext is. A slot
// name with no registered contributor is simply `undefined` here - core call
// sites treat that as "this feature isn't installed", not an error.
export const ExtensionSlotsContext = createContext({});

export function useExtensionSlot(name) {
  const slots = useContext(ExtensionSlotsContext);
  return slots[name];
}
